<template>
    <div class="flex j-c-center">
        <div class="relative">            
            <VueSlickCarousel v-bind="settings">
                <div class="div-carous" v-for="(item, index) in carousselOption" :key="index">
                    <div :style="'width:'+wid+';height:'+hei" class="opnion flex j-c-center text-center relative teste">
                        <div>
                            <div class="relative">
                                <p class="color-blue f-w-700" :style="'font-size:'+font_size_p+';padding:'+padd+';'">
                                {{item.opnion}}
                                </p>
                                <div class="absolute quotation-marks">
                                    <img class="img-responsive" src="@/assets/home/icons/quotationMark.png" alt="quotationMark">
                                </div>
                            </div>
                            <div class="absolute whoOpinion">
                                <!-- <small class="color-orange f-w-700" :style="'font-size: calc('+font_size_p+' - 12px);'">{{item.hater}}</small> -->
                                <small class="color-orange f-w-700 fontText" >{{item.hater}}</small>
                            </div>
                        </div>
                        <!-- <div class="perfilHater absolute" :style="{backgroundImage: 'url(' + item.imgPerfil + ')'}"></div> -->
                    </div>
                </div>
            </VueSlickCarousel> 
            <div class="absolute emoji" id="emoji-top" :style="$route.path == '/seja-um-franqueado' ? 'width:'+wid+50+'px;' : 'width:'+wid " >
                <img class="img-responsive" src="@/assets/home/emoji/Imagem_6.png" alt="Imagem_6.png">
            </div>
            <div class="absolute emoji emojiBottom" id="emoji-bot" :style="'width:'+wid+';'">
                <img class="img-responsive" src="@/assets/home/emoji/Imagem_2.png" alt="Imagem_2.png">
            </div>           
        </div>
    </div>
</template>


<style scoped>
    .fontText {
        font-size: 13px;
        width: 341px;
        display: flex;
        margin: 0 auto;
        align-items: center;
        justify-content: center;
    }
    @media (min-width: 990px) {
        .fontText {
            font-size: 15px;
        }
    }
    #emoji-bot img{
        width: 80px;
        position: absolute;
        right: 415px;
        top: -84px;
    }
    #emoji-top img {
        position: absolute;
        left: 388px;
    }
    
    #emoji-top{
        top: -80px;
        right: 20px;
    }

    #emoji-top img{
        width: 130px;
    }

    #emoji-bot{
        bottom: 0;
        left: -40px;
    }    

    #emoji-bot img{
        width: 80px;
    }
    .div-carous{
        width: 100%;
        height: 250px
    }

    .publicOpnion{
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
    }

    p{
        line-height: 1.5!important
    }

    .whoOpinion{
        bottom: 10px;
        right: 50%;
        -webkit-transform: translateX(50%);
                transform: translateX(50%);
    }

    .quotation-marks{
        top: -35px;
        left: 35px;
        font-weight: bolder;
    }

    .quotation-marks img{
        width: 30px;
    }


    .opnion{
        background-color: #fff;
        border-radius: 20px;  
        width: 300px;
        height: 175px;
    }
    @media only screen and (max-width: 1024px){
  
        h1{
            font-size: 50px!important;
        }

        #section_III .img-man-winner{
            left: -75px;
        }

        #emoji-top{
            top: -50px;
            right: -100px;
        }
       
    }  

    @media only screen and (max-width: 768px){
        /* .opnion{
            margin-top: 50px
        } */


        #emoji-top img{
            width: 100px;
        }

        #emoji-top{
            top: 0;
            right: 170px;
        }

        #emoji-bot{
            bottom: -50px;
            left: -30px;
        }    

        #emoji-bot img{
            width: 80px;
        }

        .quotation-marks{
            left: 20px;
            top: -35px;
        }

        p{
            margin-top: 25px;
            padding: 0 35px!important;
        }
       
    }

    @media only screen and (max-width: 420px){
        /* .opnion{
            margin-left: 30px
        }
        .opnion{
            margin-left: 7px
        } */

        #section_I{
            height: 150vh;
        }

        #emoji-top img{
            width: 100px;
        }

        #emoji-bot{
            bottom: -50px;
            left: -20px;
        }    

        #emoji-bot img{
            width: 80px;
        }
        #emoji-bot img{
            width: 80px;
            position: absolute;
            right: 238px;
            top: -89px;
        }
        #emoji-top img {
            position: absolute;
            left: 80px;
            top: 0px;
        }
    }

    @media only screen and (max-width: 767px){
        #emoji-top{
            top: 0;
            right: -60px;
        }
        
    }
   

</style>

<script>
import VueSlickCarousel from 'vue-slick-carousel' 
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    data() {
        return {
                carousselOption:[
                    {
                        opnion:"Ótima lotérica, e tem um serviço que as outras não tem. Lá você paga baratinho para imprimir seu boleto… ótimo!",
                        hater: "Danilo Almeida - Cliente",
                        
                    },
                    {
                        opnion:"Muito boa mesmo, principalmente porque tem um Fácil bem dentro da lotérica que facilita muito",
                        hater: "Nany Amorin - Cliente",
                    },
                    {
                        opnion:"Muito bom! Atendimento excelente, sempre tiro minha segunda via de conta lá, serviço prestativo",
                        hater: "Nicole Corzon - Cliente",
                    },
                    {
                        opnion:`Minha Ponto Fácil está indo muito bem, o negócio é surpreendente, pois são muitos serviços disponiveis que faz da franquia um negócio inovador.`,
                        hater: "Marcelo Scalão - Franqueado",
                    },
                    {
                        opnion:`Bom demais proporcionar ao cliente, uma solução pratíca, rápida e muito conveniente para sua necessidade! Dá-lhe Ponto Fácil`,
                        hater: "Ronaldo Miranda - Franqueado",
                    },
                    {
                        opnion:`Agora eu tenho o faturamento da lotérica e o faturamento do Ponto Facil, e foi isso que me trouxe uma situação de conforto financeiramente falando. Eu consegui pagar o meu investimento do Ponto Facil em apenas 5 meses.`,
                        hater: "Osvaldo Oliveira - Franqueado",
                    },
                ],
                settings:
                {
                    "dots": false,
                    "autoplay": true,
                    "infinite": true,
                    "autoplaySpeed": 3500,
                    "slidesToShow": 1,
                    "slidesToScroll": 1,
                    "vertical":true,
                    "arrows":false,
                    'loop': true,
                    'fade': true
                }
            }
    },
    components: { VueSlickCarousel },
    props:["wid", "hei", "font_size_p", "padd"]
}
</script>